import { useMutation, useQuery } from "@tanstack/react-query";
import {
  ActionsService,
  ActionsFindAllPayload,
} from "../services/actions.service";
import { ActionPayload } from "../domain/actions.interface";

export const useActions = (filters: ActionsFindAllPayload) => {
  const {
    data: actions,
    isLoading: isLoadingActions,
    isFetching: isFetchingActions,
    refetch: refetchActions,
  } = useQuery({
    queryKey: ["parca-actions-list"],
    queryFn: () => ActionsService.findAll(filters),
  });

  return {
    actions,
    isLoadingActions,
    isFetchingActions,
    refetchActions,
  };
};

const CATALOG_FILTERS: ActionsFindAllPayload = {
  sortField: "name",
  sortOrder: 1,
  pageNumber: 0,
  pageSize: 500,
  search: "",
  status: "",
  type: "",
};

export const useActionsCatalog = (enabled = true) => {
  const {
    data: actionsCatalog,
    isLoading: isLoadingActionsCatalog,
    refetch: refetchActionsCatalog,
  } = useQuery({
    queryKey: ["parca-actions-catalog"],
    queryFn: () => ActionsService.findAll(CATALOG_FILTERS),
    enabled,
  });

  return {
    actionsCatalog,
    isLoadingActionsCatalog,
    refetchActionsCatalog,
  };
};

export const useCreateAction = () => {
  return useMutation({
    mutationFn: (payload: ActionPayload) => ActionsService.createOne(payload),
  });
};

export const useUpdateAction = () => {
  return useMutation({
    mutationFn: ({ id, payload }: { id: string; payload: ActionPayload }) =>
      ActionsService.updateOne({ id, payload }),
  });
};

export const useArchiveAction = () => {
  return useMutation({
    mutationFn: (id: string) => ActionsService.archiveOne(id),
  });
};
